/* Adds prev/next arrows beside the main product image. Reuses Dawn's thumbnail
   switching (each arrow clicks the adjacent thumbnail), so media-gallery.js is
   untouched. No-JS users still have the thumbnail strip. */
(function () {
  const caret =
    '<svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeArrow(dir, gallery) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cust-gallery-arrow cust-gallery-arrow--' + dir;
    btn.setAttribute('aria-label', dir === 'next' ? 'Next image' : 'Previous image');
    btn.innerHTML = caret;
    btn.addEventListener('click', () => {
      const thumbs = Array.from(
        gallery.querySelectorAll('[id^="GalleryThumbnails"] .thumbnail')
      );
      if (thumbs.length < 2) return;
      let idx = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
      if (idx < 0) idx = 0;
      const next = (idx + (dir === 'next' ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].click();
    });
    return btn;
  }

  function init(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbs = gallery.querySelectorAll('[id^="GalleryThumbnails"] .thumbnail');
    if (!viewer || thumbs.length < 2) return;
    if (viewer.querySelector('.cust-gallery-arrow')) return;
    viewer.classList.add('cust-gallery-viewer');
    viewer.appendChild(makeArrow('prev', gallery));
    viewer.appendChild(makeArrow('next', gallery));
  }

  document.querySelectorAll('media-gallery').forEach(init);
})();
